enum ToastType {
  Success = "Success",
  Error = "Error",
}
export default ToastType;
